__turbopack_context__.v({
  "activeArrow": "WorkExperience-module__XNWFhG__activeArrow",
  "body": "WorkExperience-module__XNWFhG__body",
  "entry": "WorkExperience-module__XNWFhG__entry",
  "entryLinks": "WorkExperience-module__XNWFhG__entryLinks",
  "footer": "WorkExperience-module__XNWFhG__footer",
  "group": "WorkExperience-module__XNWFhG__group",
  "head": "WorkExperience-module__XNWFhG__head",
  "heading": "WorkExperience-module__XNWFhG__heading",
  "inner": "WorkExperience-module__XNWFhG__inner",
  "label": "WorkExperience-module__XNWFhG__label",
  "list": "WorkExperience-module__XNWFhG__list",
  "period": "WorkExperience-module__XNWFhG__period",
  "section": "WorkExperience-module__XNWFhG__section",
  "stat": "WorkExperience-module__XNWFhG__stat",
  "statGrid": "WorkExperience-module__XNWFhG__statGrid",
  "sub": "WorkExperience-module__XNWFhG__sub",
  "subLink": "WorkExperience-module__XNWFhG__subLink",
  "title": "WorkExperience-module__XNWFhG__title",
});
